import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center px-4 py-3 bg-white border-b border-gray-200 hover:bg-gray-50 transition-colors" };
const _hoisted_2 = { class: "w-56 flex flex-col gap-0.5 shrink-0" };
const _hoisted_3 = { class: "text-sm font-medium text-gray-900" };
const _hoisted_4 = { class: "w-28 shrink-0" };
const _hoisted_5 = { class: "w-24 shrink-0" };
const _hoisted_6 = { class: "text-sm text-gray-900" };
const _hoisted_7 = { class: "flex items-center gap-2 ml-auto" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChargeTableRow',
    props: {
        template: {}
    },
    emits: ["edit", "delete"],
    setup(__props) {
        const props = __props;
        const formattedAmount = computed(() => {
            if (props.template.type === 'PERCENTAGE') {
                return `${props.template.amount}%`;
            }
            return `$${props.template.amount.toFixed(2)}`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.template.name), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", {
                        class: _normalizeClass(["inline-flex items-center px-2 py-0.5 rounded text-xs font-medium", __props.template.type === 'FLAT' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'])
                    }, _toDisplayString(__props.template.type === 'FLAT' ? _ctx.$t("services.charges.types.flat") : _ctx.$t("services.charges.types.percentage")), 3)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(formattedAmount.value), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "flex items-center gap-1.5 px-2.5 py-1.5 text-xs text-gray-500 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('edit', __props.template.id)))
                    }, [
                        _cache[2] || (_cache[2] = _createElementVNode("svg", {
                            class: "w-3 h-3",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "stroke-width": "2",
                            stroke: "currentColor"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125"
                            })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.edit")), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "flex items-center gap-1.5 px-2.5 py-1.5 text-xs text-red-600 bg-red-50 border border-red-200 rounded-md hover:bg-red-100 transition-colors",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('delete', __props.template.id)))
                    }, [
                        _cache[3] || (_cache[3] = _createElementVNode("svg", {
                            class: "w-3 h-3",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "stroke-width": "2",
                            stroke: "currentColor"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                            })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.delete")), 1)
                    ])
                ])
            ]));
        };
    }
});
